import type { StepsDesignTokens } from '@primeuix/themes/types/steps'

export default {
  root: {
    transitionDuration: '{transition.duration}',
  },
  itemLink: {
    gap: '0.5rem',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    borderRadius: '{content.border.radius}',
  },
  itemLabel: {
    color: '{text.muted.color}',
    fontWeight: '500',
    activeColor: '{primary.color}',
  },
  separator: {
    background: '{content.border.color}',
  },
  itemNumber: {
    size: '2.25rem',
    color: '{text.muted.color}',
    shadow: 'none',
    fontSize: '1.125rem',
    background: '{content.background}',
    fontWeight: '500',
    activeColor: '{primary.contrast.color}',
    borderColor: '{content.border.color}',
    borderRadius: '50%',
    activeBackground: '{primary.color}',
    activeBorderColor: '{primary.color}',
  },
} satisfies StepsDesignTokens
